<script setup>
import { computed } from 'vue'

const props = defineProps({
  icon: { type: String, required: true },
  label: { type: String, required: true },
  color: { type: String, default: '#0ea5e9' },
  angle: { type: Number, required: true },
  radius: { type: Number, default: 70 },
  isOpen: { type: Boolean, default: false },
  delay: { type: Number, default: 0 },
  badge: { type: [Number, String], default: 0 }
})

const emit = defineEmits(['click'])

// 用 left/top 定位，transform 仅用于 scale 动画，避免 hover 冲突
const bubbleStyle = computed(() => {
  const rad = (props.angle * Math.PI) / 180
  const x = props.isOpen ? Math.cos(rad) * props.radius : 0
  const y = props.isOpen ? Math.sin(rad) * props.radius : 0
  return {
    left: `${x - 22}px`,
    top: `${y - 22}px`,
    transform: `scale(${props.isOpen ? 1 : 0})`,
    opacity: props.isOpen ? 1 : 0,
    transitionDelay: props.isOpen ? `${props.delay}ms` : '0ms',
    background: `linear-gradient(135deg, ${props.color} 0%, ${props.color}cc 100%)`
  }
})
</script>

<template>
  <div
    class="sub-bubble"
    :style="bubbleStyle"
    :title="label"
    @click.stop="emit('click')"
  >
    <span class="sub-icon">{{ icon }}</span>
    <span class="sub-label">{{ label }}</span>
    <span v-if="badge && Number(badge) > 0" class="sub-badge">
      {{ Number(badge) > 99 ? '99+' : badge }}
    </span>
  </div>
</template>

<style scoped>
.sub-bubble {
  position: absolute;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  cursor: pointer;
  box-shadow: 0 3px 12px rgba(14, 165, 233, 0.35);
  transition: left 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
              top 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
              transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
              opacity 0.25s ease,
              box-shadow 0.2s ease;
  user-select: none;
  z-index: 1;
}

.sub-bubble:hover {
  transform: scale(1.18);
  box-shadow: 0 5px 18px rgba(14, 165, 233, 0.5);
}

.sub-icon {
  font-size: 18px;
  line-height: 1;
}

.sub-label {
  font-size: 8px;
  font-weight: 500;
  margin-top: 1px;
  white-space: nowrap;
}

.sub-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: #ef4444;
  color: white;
  font-size: 9px;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(239, 68, 68, 0.4);
}
</style>
